import { createApiRef } from '@backstage/core-plugin-api';
import { GitlabRegistryRepository } from './dto/response/gitlab-registry-repository';
import { GitlabRegistryRepositoryDetail } from './dto/response/gitlab-registry-repository-detail';
import { GitlabTagDetail } from './dto/response/gitlab-registry-tag-detail';

export interface GitlabRegistryApi {
    listRepositories(page: number, perPage: number): Promise<{
        repos: GitlabRegistryRepository[];
        total: number;
        totalPages: number;
    }>;

    getRepository(repositoryId: number): Promise<{ repository: GitlabRegistryRepositoryDetail }>;
    getTag(repositoryId: number, tagName: string): Promise<{ tag: GitlabTagDetail }>;
}

export const gitlabRegistryApiRef = createApiRef<GitlabRegistryApi>({
    id: 'plugin.gitlab.registry.service',
});
